import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-white/95 backdrop-blur-md border-b border-background-200/80'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center space-x-2 flex-shrink-0">
          <span className={`font-heading text-2xl font-bold transition-colors duration-300 ${
            scrolled || !isHome ? 'text-primary-500' : 'text-white'
          }`}>
            91看片网
          </span>
        </Link>

        <div className="hidden md:flex items-center space-x-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/'
                ? scrolled ? 'bg-primary-50 text-primary-600' : 'bg-white/20 text-white'
                : scrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-white/90 hover:bg-white/10'
            }`}
          >
            首页
          </Link>

          <div className="relative">
            <button
              onClick={() => setCategoryOpen(!categoryOpen)}
              className={`flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                scrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-white/90 hover:bg-white/10'
              }`}
              aria-expanded={categoryOpen}
              aria-haspopup="true"
            >
              分类
              <i className={`ri-arrow-down-s-line ml-1 transition-transform duration-200 ${categoryOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {categoryOpen && (
              <div className="absolute top-full left-0 mt-1 w-48 bg-white rounded-lg border border-background-200/80 py-1 animate-[fadeIn_0.15s_ease-out]">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="flex items-center px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-50 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    <i className={`${cat.icon} mr-2 text-base`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
            )}
          </div>

          <Link
            to="/about"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === '/about'
                ? scrolled ? 'bg-primary-50 text-primary-600' : 'bg-white/20 text-white'
                : scrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-white/90 hover:bg-white/10'
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center space-x-3">
          <div className={`flex items-center px-3 py-1.5 rounded-full text-sm ${
            scrolled ? 'bg-background-100 text-foreground-500' : 'bg-white/15 text-white/80'
          }`}>
            <i className="ri-search-line mr-1.5 text-sm"></i>
            <span>搜索文章...</span>
          </div>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${
            scrolled || !isHome ? 'text-foreground-700' : 'text-white'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-background-200 animate-[fadeIn_0.2s_ease-out]">
          <div className="px-4 py-3 space-y-1">
            <Link to="/" className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-50 whitespace-nowrap">首页</Link>
            <div className="text-sm font-medium text-foreground-400 px-4 py-1">分类</div>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="flex items-center px-4 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-50 whitespace-nowrap"
              >
                <i className={`${cat.icon} mr-2 text-base`}></i>
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-50 whitespace-nowrap">关于我们</Link>
          </div>
        </div>
      )}
    </header>
  );
}